import { MARKER_PROPS } from '../const';

const MarkerDefinitions = () => (
  <>
    {/* Both line endings & beginnings */}

    <marker id="null"></marker>
    <marker id="none"></marker>
    <marker id="undefined"></marker>

    {/* Line endings */}
    <marker
      id="circle"
      stroke="black"
      strokeWidth="2"
      refX={MARKER_PROPS.circle.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 8 8"
      markerWidth={MARKER_PROPS.circle.markerWidth}
      markerHeight="8"
      orient="auto"
    >
      <circle style={{ strokeDasharray: 0 }} cx="4" cy="4" r="3"></circle>
    </marker>

    <marker
      id="top"
      refX={MARKER_PROPS.top.refX}
      refY="3.5"
      markerUnits="strokeWidth"
      viewBox="0 0 4 4"
      markerWidth={MARKER_PROPS.top.markerWidth}
      markerHeight="4"
      orient="auto"
      stroke="black"
      strokeWidth="1"
    >
      <path style={{ strokeDasharray: 0 }} d="M 0 0 L 0 0 L 3.6 4"></path>
    </marker>

    <marker
      id="diamond"
      refX={MARKER_PROPS.diamond.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 8"
      markerWidth={MARKER_PROPS.diamond.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 5 1 L 10 4 L 5 7 M 5 1 L 0 4 L 5 7"
        fill="#fff"
      />
    </marker>

    <marker
      id="diamondFilled"
      refX={MARKER_PROPS.diamondFilled.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 8"
      markerWidth={MARKER_PROPS.diamondFilled.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 5 1 L 10 4 L 5 7 M 5 1 L 0 4 L 5 7"
        fill="black"
      />
    </marker>

    <marker
      id="bottom"
      refX={MARKER_PROPS.bottom.refX}
      refY="0.5"
      stroke="black"
      strokeWidth="1"
      markerUnits="strokeWidth"
      viewBox="0 0 4 4"
      markerWidth={MARKER_PROPS.bottom.markerWidth}
      markerHeight="4"
      orient="auto"
    >
      <path style={{ strokeDasharray: 0 }} d="M 0 4 L 0 4 L 3.6 0"></path>
    </marker>

    <marker
      id="both"
      refX={MARKER_PROPS.both.refX}
      refY="4"
      stroke="black"
      strokeWidth="1"
      markerUnits="strokeWidth"
      viewBox="0 0 4 8"
      markerWidth={MARKER_PROPS.both.markerWidth}
      markerHeight="8"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0 }}
        d="M 0 0 L 0 0 L 3.3 4 L 0 8"
        fill="none"
      />
    </marker>

    <marker
      id="bothFilled"
      refX={MARKER_PROPS.bothFilled.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 3 8"
      markerWidth={MARKER_PROPS.bothFilled.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0 }}
        d="M -1 1 L -1 1 L 2.2 4 L -1 7"
        fill="black"
      />
    </marker>

    <marker
      id="bothOutlined"
      refX={MARKER_PROPS.bothOutlined.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 -2 6 10"
      markerWidth={MARKER_PROPS.bothOutlined.markerWidth}
      markerHeight="12"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 5.4 4 L 0.5 8 L 0.5 0 L 5.4 4 L 0.5 8"
        fill="#fff"
      />
    </marker>

    {/* Line beginning */}
    <marker
      id="circleStart"
      stroke="black"
      strokeWidth="2"
      refX={MARKER_PROPS.circleStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 8 8"
      markerWidth={MARKER_PROPS.circleStart.markerWidth}
      markerHeight="8"
      orient="auto"
    >
      <circle style={{ strokeDasharray: 0 }} cx="4" cy="4" r="3"></circle>
    </marker>

    <marker
      id="diamondStart"
      refX={MARKER_PROPS.diamondStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 8"
      markerWidth={MARKER_PROPS.diamondStart.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 5 1 L 10 4 L 5 7 M 5 1 L 0 4 L 5 7"
        fill="#fff"
      />
    </marker>

    <marker
      id="diamondFilledStart"
      refX={MARKER_PROPS.diamondFilledStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 8"
      markerWidth={MARKER_PROPS.diamondFilledStart.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 5 1 L 10 4 L 5 7 M 5 1 L 0 4 L 5 7"
        fill="black"
      />
    </marker>

    <marker
      id="topStart"
      refX={MARKER_PROPS.topStart.refX}
      refY="3.5"
      markerUnits="strokeWidth"
      viewBox="0 0 4 4"
      markerWidth={MARKER_PROPS.topStart.markerWidth}
      markerHeight="4"
      orient="auto"
      stroke="black"
      strokeWidth="1"
    >
      <path style={{ strokeDasharray: 0 }} d="M 4.0 0 L 4.0 0 L 0.4 4"></path>
    </marker>

    <marker
      id="bottomStart"
      refX={MARKER_PROPS.bottomStart.refX}
      refY="0.5"
      stroke="black"
      strokeWidth="1"
      markerUnits="strokeWidth"
      viewBox="0 0 4 4"
      markerWidth={MARKER_PROPS.bottomStart.markerWidth}
      markerHeight="4"
      orient="auto"
    >
      <path style={{ strokeDasharray: 0 }} d="M 4 4 L 4 4 L 0.4 0"></path>
    </marker>

    <marker
      id="bothStart"
      refX={MARKER_PROPS.bothStart.refX}
      refY="4"
      stroke="black"
      strokeWidth="1"
      markerUnits="strokeWidth"
      viewBox="0 0 4 8"
      markerWidth={MARKER_PROPS.bothStart.markerWidth}
      markerHeight="8"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0 }}
        fill="none"
        d="M 4.0  0 L 4.0  0 L 0.7 4 L 4.0  8"
      />
    </marker>

    <marker
      id="bothFilledStart"
      refX={MARKER_PROPS.bothFilledStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 3 8"
      markerWidth={MARKER_PROPS.bothFilledStart.markerWidth}
      markerHeight="8"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0 }}
        d="M 4 1 L 4 1 L 0.8 4 L 4 7"
        fill="black"
      />
    </marker>

    <marker
      id="bothOutlinedStart"
      refX={MARKER_PROPS.bothOutlinedStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 -2 6 10"
      markerWidth={MARKER_PROPS.bothOutlinedStart.markerWidth}
      markerHeight="12"
      stroke="black"
      strokeWidth="1"
      orient="auto"
    >
      <path
        style={{ strokeDasharray: 0, strokeWidth: 0.7 }}
        d="M 0.6 4 L 5.5 8 L 5.5 0 L 0.6 4 L 5.5 8"
        fill="#fff"
      />
    </marker>

    <marker
      id="one"
      refX={MARKER_PROPS.one.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 10"
      markerWidth={MARKER_PROPS.one.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path style={{ strokeDasharray: 0, strokeWidth: 0.5 }} d="M5 0 L5 8 Z" />
    </marker>

    <marker
      id="oneStart"
      refX={MARKER_PROPS.oneStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 10"
      markerWidth={MARKER_PROPS.oneStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path style={{ strokeDasharray: 0, strokeWidth: 0.5 }} d="M5 0 L5 8 Z" />
    </marker>

    <marker
      id="oneMandatory"
      refX={MARKER_PROPS.oneMandatory.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 10"
      markerWidth={MARKER_PROPS.oneMandatory.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M6 0 L6 8 Z" />
      <path style={{ strokeDasharray: 0, strokeWidth: 0.7 }} d="M2 0 L2 8 Z" />
    </marker>

    <marker
      id="oneMandatoryStart"
      refX={MARKER_PROPS.oneMandatoryStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 10"
      markerWidth={MARKER_PROPS.oneMandatoryStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path style={{ strokeDasharray: 0, strokeWidth: 0.7 }} d="M4 0 L4 8 Z" />
      <path d="M8 0 L8 8 Z" />
    </marker>

    <marker
      id="many"
      refX={MARKER_PROPS.many.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 12 10"
      markerWidth={MARKER_PROPS.many.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M6 4 L6 4 L11.7 0.42 L6 4 L12 4 L6 4 L11.7 7.58 L6 4 Z" />
    </marker>

    <marker
      id="manyStart"
      refX={MARKER_PROPS.manyStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 12 10"
      markerWidth={MARKER_PROPS.manyStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M6 4 L6 4 L0.3 0.42 L6 4 L0 4 L6 4 L0.3 7.58 L6 4 Z" />
    </marker>

    <marker
      id="oneOrMany"
      refX={MARKER_PROPS.oneOrMany.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 12 10"
      markerWidth={MARKER_PROPS.oneOrMany.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M6 4 L6 4 L11.7 0.42 L6 4 L12 4 L6 4 L11.7 7.58 L6 4 Z" />
      <g transform="translate(4,0)">
        <path d="M0 0 L0 8 Z" />
      </g>
    </marker>

    <marker
      id="oneOrManyStart"
      refX={MARKER_PROPS.oneOrManyStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 12 10"
      markerWidth={MARKER_PROPS.oneOrManyStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M6 4 L6 4 L0.3 0.42 L6 4 L0 4 L6 4 L0.3 7.58 L6 4 Z" />
      <g transform="translate(8,0)">
        <path d="M0 0 L0 8 Z" />
      </g>
    </marker>

    <marker
      id="zeroOrOne"
      refX={MARKER_PROPS.zeroOrOne.refX}
      refY="4"
      markerUnits="strokeWidth"
      markerWidth={MARKER_PROPS.zeroOrOne.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <circle
        style={{ strokeDasharray: 0, fill: 'white' }}
        cx="6.5"
        cy="4"
        r="3"
        fill="#fff"
      />
      <path d="M0 0 L0 8 Z" />
    </marker>

    <marker
      id="zeroOrOneStart"
      refX={MARKER_PROPS.zeroOrOneStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 10 10"
      markerWidth={MARKER_PROPS.zeroOrOneStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <circle
        style={{ strokeDasharray: 0, fill: 'white' }}
        cx="3.5"
        cy="4"
        r="3"
        fill="#fff"
      />
      <g transform="translate(9,0)">
        <path d="M0 0 L0 8 Z" />
      </g>
    </marker>

    <marker
      id="zeroOrMany"
      refX={MARKER_PROPS.zeroOrMany.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 16 10"
      markerWidth={MARKER_PROPS.zeroOrMany.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <circle
        style={{ strokeDasharray: 0, fill: 'white' }}
        cx="4"
        cy="4"
        r="3"
        fill="#fff"
      />
      <g transform="translate(4,0)">
        <path d="M6 4 L6 4 L11.7 0.42 L6 4 L12 4 L6 4 L11.7 7.58 L6 4 Z" />
      </g>
    </marker>

    <marker
      id="zeroOrManyStart"
      refX={MARKER_PROPS.zeroOrManyStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 16 10"
      markerWidth={MARKER_PROPS.zeroOrManyStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <g transform="translate(8,0)">
        <circle
          style={{ strokeDasharray: 0, fill: 'white' }}
          cx="4"
          cy="4"
          r="3"
          fill="#fff"
        />
      </g>
      <path d="M6 4 L6 4 L0.3 0.42 L6 4 L0 4 L6 4 L0.3 7.58 L6 4 Z" />
    </marker>

    <marker
      id="default"
      refX={MARKER_PROPS.default.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 11 11"
      markerWidth={MARKER_PROPS.default.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M8 0 L0 8 Z" />
    </marker>

    <marker
      id="defaultStart"
      refX={MARKER_PROPS.defaultStart.refX}
      refY="4"
      markerUnits="strokeWidth"
      viewBox="0 0 11 11"
      markerWidth={MARKER_PROPS.defaultStart.markerWidth}
      markerHeight="10"
      strokeWidth="1"
      orient="auto"
      stroke="black"
    >
      <path d="M8 0 L0 8 Z" />
    </marker>
  </>
);

export { MarkerDefinitions };

